<template>

  <v-container>
    <v-layout
      text-center
      wrap
    >
     

      <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12" v-if="!success">
              <v-toolbar
                color="primary"
                dark
                flat
              >

                <v-toolbar-title>Participa en el Sorteo</v-toolbar-title>
                <v-spacer />
                
                <v-tooltip bottom>
                  
           
                </v-tooltip>
                <v-tooltip right>
                  
                  
                </v-tooltip>
              </v-toolbar>
              <v-card-text>
              <p class="display-1 text--primary">
                Completa tus datos
              </p>
              <div>Deja tu nombre y número de teléfono para participar</div>
      

                <v-form>
                  <i class="fa fa-user" aria-hidden="true"></i>
                  <v-text-field
                    label="Nombre"
                    name="login"
                    type="text"
                    v-model="nombre"
                  />

                  <v-text-field
                    id="telephone"
                    label="Telefono"
                    name="telephone"
                    type="text"
                    v-model="telefono"
                  />
                  {{ socio }}
                   <v-select
                    v-model="socio"
          :items="items"
          label="¿Sos Socio?"
          outlined
        ></v-select>
                </v-form>
                <div class="wrap-input100">
                    <div v-if="errores.length">
                        <p class="m-text11">Verifique lo(s) siguiente(s) errores:</p>
                        <ul class="text-left">
                            <li class="label-input100" v-for="(error, key) in errores" v-bind:key="key">{{ error }}</li>
                        </ul>
                    </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn large class="ml-5" color="primary" @click="enviarform()"
                  :loading="loading" >Participar</v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-if="success"
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <div>Perfecto!</div>
      <p class="display-1 text--primary">
       Ya estás participando
      </p>
      <p>Informaremos por facebook e instagram el ganador</p>
     
    </v-card-text>
    <v-card-actions>
      <v-btn large class="ml-5" color="primary" @click="gotoWeb()">Volver a la web</v-btn>
    </v-card-actions>
  </v-card>
          </v-col>
        </v-row>

      

    
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: 'HelloWorld',

  data: () => ({
    nombre: '',
    telefono: '',
    socio: undefined,
    response: undefined,
    errored: false,
    loading: false,
    inputId: undefined,
    success: false,
    errores: [],
    items: [{text: 'Soy Socio', value: 'socio'}, {text: 'Soy Particular', value: 'particular'}]
  }),
  methods: {
    gotoWeb: function(){
      window.location = 'https://motoupa.com.uy/?utm_source=sorteo'
    },
    callApi: function() {
      this.loading = true;
      this.response = undefined;
      let url = 'http://api-gateway.motoupa.com.uy/api/sorteo/participar';
      let cliente =  {         
        nombre: this.nombre,
        telefono: this.telefono,
        socio: this.socio
        };
        axios.post(url, {
        "cliente": cliente
        }).then(response => {
              this.response = response.data;
              this.loading = false;
              this.success = true;
            })
            .catch(error => {
              console.log(error);
              this.response = error;
              this.errored = true;
              this.loading = false;
            });
    },
    enviarform: function () {
        if(this.verificarForm() === true){
           this.callApi();
        }
    },
    verificarForm: function (){
      this.errores = []
      if (this.nombre === '') {
          this.errores.push("Indique su Nombre Completo")
        }
      if (this.socio === '' || this.socio === undefined) {
          this.errores.push("Indique si es socio")
        }
        if (this.telefono === '') {
          this.errores.push("Indique su Celular")
        } else {
          if (this.verificarcelular(this.telefono) === false) {
            this.errores.push("Número de Celular no válido")
          }
        }
      if(!this.errores.length) {
          return true
        } else {
          return false
        }
    },
    verificarcelular (actual) {
    var re = /(\d{3})(\d{3})(\d{3})/g;
    var nuevo = actual.replace(re, "$1$2$3");
    var codigo = actual.replace(re, "$1");
      
      if(codigo <= 99){
      switch(codigo) {
      case '091':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
      break;
      case '092':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '093':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '094':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '095':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '096':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '097':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '098':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '099':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      default:
          return false;
  }
      }else{
          return false;
      }
    },
  }
};
</script>
